import { render, staticRenderFns } from "./RootBookingWindowForm.vue?vue&type=template&id=533ca4b1&scoped=true&"
import script from "./RootBookingWindowForm.vue?vue&type=script&lang=js&"
export * from "./RootBookingWindowForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "533ca4b1",
  null
  
)

export default component.exports